import { AUTH_SESSION, LOGOUT } from './types';
const initialState = {
    access_token: '',
    account_id: '',
    expires: 0,
    include: {
        patient: {
            firstName: '',
            lastName: '',
            email: '',
            dateOfBirth: '',
            language: '',
            country: '',
            consents: {
                hipaa: { accepted: false, at: 0, latestVersion: 0 },
                pp: { accepted: false, at: 0, latestVersion: 0 },
                realWorldEvidence: { accepted: false, at: 0, latestVersion: 0 },
                touLibre: { accepted: false, at: 0, latestVersion: 0 },
            },
        },
    },
};
export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SESSION:
            return {
                ...state,
                ...action.authSession,
            };
        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
